import useFeature from "@casino/legacy/client/hooks/feature/useFeature";
import FormRegister from "./FormRegister";
import RegisterWrapper from "./RegisterFormWrapper";

type Props = {
  handleSuccess?: () => void;
  isPopover?: boolean;
};

const RegisterBody: FC<Props> = ({ handleSuccess, isPopover = false }) => {
  const showSignUpSocialAuth = useFeature("signUpSocialAuth");

  return (
    <RegisterWrapper
      translateId="profile.signup"
      showSignUpSocialAuth={showSignUpSocialAuth}
    >
      <FormRegister onSubmitHandle={handleSuccess} isPopover={isPopover} />
    </RegisterWrapper>
  );
};

export default RegisterBody;
